export default {
    getSavedConfig(state) {
        return state;
    },
};